import {
  drawerWidth,
  transition,
  container,
  whiteColor,
  backgroundColor
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => {
  return {
    "@global": {
      body: {
        backgroundColor: backgroundColor
      }
    },
    wrapper: {
      position: "relative",
      top: "0",
      height: "100vh"
    },
    mainPanel: {
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}px)`
      },
      overflow: "auto",
      position: "relative",
      float: "right",
      ...transition,
      maxHeight: "100%",
      width: "100%",
      overflowScrolling: "touch",
      color: whiteColor,
      backgroundColor: backgroundColor
    },
    content: {
      marginTop: "30px",
      padding: "30px 5px",
      minHeight: "calc(100vh - 123px)",
      backgroundColor: backgroundColor,
      color: whiteColor
    },
    container: {
      ...(typeof container === "function" ? container(theme) : container),
      backgroundColor: backgroundColor,
      color: whiteColor
    },
    map: {
      marginTop: "70px"
    }
  };
};

export default appStyle;
